



























import Vue, { PropType } from "vue";
import { PPCollectItem } from "@/picking-portal/models/PPOrder";

export default Vue.extend({
  name: "PPOrderItemsTable",
  props: {
    items: {
      type: Array as PropType<Array<PPCollectItem>>,
      required: true,
    },
  },
  computed: {
    sortedItems(): PPCollectItem[] {
      return [...this.items].sort(
        (a, b) =>
          a.productLocation.localeCompare(b.productLocation, undefined, { numeric: true, sensitivity: "base" }) ||
          a.description.localeCompare(b.description, undefined, { numeric: true, sensitivity: "base" })
      );
    },
  },
});
